import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import {DEFAULT_CIRCLE_SIZE_PIXELS } from '../../../constants'; //COLORS_PROJECT,
import Circle from '../../ui/Circle';

export const IconSwitchLevel = ({number,sizePixels = DEFAULT_CIRCLE_SIZE_PIXELS }) => {

    //const {color_alarm_green,color_alarm_yellow,color_alarm_orange,color_alarm_red}=COLORS_PROJECT;
    const {colorPoints} = useSelector(state => state.auth)
    const arrColors = colorPoints.split(",")
       switch (number) {
        case 1:
             
            return (<Circle color={arrColors[1]} sizePixels={sizePixels}/>);

        case 2:
            
            return (<Circle color={arrColors[2]} sizePixels={sizePixels}/>);

        case 3:
            
            return (<Circle color={arrColors[3]} sizePixels={sizePixels}/>);
    
        default:
            return (<Circle color={arrColors[0]} sizePixels={sizePixels}/>);
    }

    
}

IconSwitchLevel.propTypes = {
    number: PropTypes.number.isRequired,
    sizePixels: PropTypes.number,
};
